import { getParameterByName } from './get-parameter-by-name.function';

export function redirectAfterLogin({ token, thirdParty, redirectUri }: { token?: string; thirdParty?: boolean; redirectUri?: string }): void {
  const redirect = redirectUri ? redirectUri : getParameterByName('redirect');
  if (redirect && token) {
    const url = new URL(redirect);

    if (!thirdParty) {
      url.searchParams.set('token', token);
    }

    window.location.href = url.toString();
  }
}
